import { apiClient, BASE_URL } from "../lib/api-client";
import { client } from "./api/client.gen";

client.setConfig({
  axios: apiClient,
  baseURL: BASE_URL,
});
